import { useState, useContext } from 'react';

import { ModalContext, AppContext, EMPTY_ARRAY, ONE_DAY_MILLI_SEC, ONE_MIN_IN_MILLI_SEC } from 'commons-ui';
import useService from '../../useService';

const useContent = () => {
	const { getTransactionPdf } = useService();

	const [showLoader, setShowLoader] = useState(false);
	const { setModalConfig } = useContext(ModalContext);
	const { showAlert } = useContext(AppContext);

	const handleFormSubmit = async (submittedData: any) => {
		try {
			setShowLoader(true);
			const [minTime = new Date(0), maxTime = new Date()] = submittedData?.dateRange;
			const maxTimeInMilliSec: number = maxTime.getTime() + ONE_DAY_MILLI_SEC;
			const currentTime: number = Date.now() - ONE_MIN_IN_MILLI_SEC;
			const adjustedMaxTime: number = maxTimeInMilliSec < currentTime ? maxTimeInMilliSec : currentTime;
			const tidsToHighlight: string[] = submittedData?.tidsToHighlight?.split(',') || EMPTY_ARRAY;
			const fileUrl: string = await getTransactionPdf({
				minTime: minTime.getTime(),
				maxTime: adjustedMaxTime,
				tidsToHighlight
			});
			window.open(fileUrl, '_blank');
			setShowLoader(false);
		} catch (error) {
			showAlert('Error in Fetching Transaction Pdf', { type: 'error' });
		} finally {
			setModalConfig({ isOpen: false });
		}
	};

	const handleFormCancel = () => {
		setModalConfig({ isOpen: false });
	};

	return {
		showLoader,
		setShowLoader,
		handleFormCancel,
		handleFormSubmit
	};
};

export default useContent;
